<template>
  <div class="buttons-wrapper">
    <div>
      <slot name="leftTop" />
    </div>
    <div>
      <slot name="rightTop" />
    </div>
    <div>
      <slot name="leftBottom" />
    </div>
    <div>
      <slot name="rightBottom" />
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.buttons-wrapper {
  display: grid;
  grid-template-columns: auto auto;
  gap: 16px;
}
</style>